import { IconProps } from '.'

// TODO Determine the use and need for this icon, it may have a valid usecase to match the output of Notifications
const Attachments = ({ title = 'Attachment', ...rest }: IconProps) => {
  return (
    <span role="img" aria-label={title} {...rest}>
      📎
    </span>
  )
}

Attachments.needsWork = true
Attachments.displayName = 'Attachments'
export default Attachments
